import { getChannelAPIPath } from '@treasury/core/http';

DownloadService.$inject = ['$resource', '$q', '$http'];

export default function DownloadService($resource, $q, $http) {
    return {
        download,
        email,
        getQboSettings,
        getQfxEnabledFlag,
    };

    function download(options) {
        return $http
            .post(`${getChannelAPIPath()}download/`, options, { responseType: 'arraybuffer' })
            .then(response => response.data);
    }

    function email(form) {
        return $resource(`${getChannelAPIPath()}download/email`).save(form).$promise;
    }

    function getQboSettings() {
        return $http
            .get(`${getChannelAPIPath()}download/qboSettings`)
            .then(response => response.data);
    }

    function getQfxEnabledFlag() {
        return $http
            .get(`${getChannelAPIPath()}download/getQfxEnabledFlag`)
            .then(response => response.data);
    }
}
